export const ROOT = "/";
export const PUNCH = "/punch";
export const ADD_WORKER = "/add-worker";
export const REVIEW = "/review";
export const DSC = "/dsc";
export const ADD_TIMESHEET = "/add-timesheet";
export const DSC_EMPLOYEE_LEVEL_PLANING = "/dsc-employee-level-planning";
export const ADD_EDIT_EMPLOYEE_DSC = "/dsc-employee-level-planning/plan";
export const ADD_EDIT_PUNCH_SUPERVISOR = "/supervisor-punch";
export const SUPERVISOR_PTO = "/supervisor-pto";

export const MANAGE_ACTIVITY_GROUP = "/review/manage-activity-group";

//Duration column constants for report and allpunch filter
export const ALLPUNCH_DURATION = 11;
export const REPORT_DURATION = 15;

// New routes
export const ALL_ACTIVITIES = "/review/all-activities";
export const ALL_HIGH_DURATION_ACTIVITIES = "/review/review-high-duration";
export const MANAGE_WORKERS = "/review/manage-workers";
export const REPORTS = "/review/reports";
export const ACTIVITIES = "/review/activities";
export const ADD_EDIT_ACTIVITY = "/add-edit-activity";
export const INCOMPLETE_PUNCHES = "/review/review-incomplete";
export const TRANSPORT_TRIP = "/review/transport-details";

// covid19
export const COVID_19 = "/alt-registration";
export const COVID_19_SUCCESS = "/alt-registration_success";

//restructure timesheet
export const MANAGE_TIMESHEET = "/review/manage-timesheet";

// driver form - IM WEBVIEW

export const DRIVER_FORM = "/route-update";
export const DRIVER_FORM_SUCCESS = "/route-update-success";

// ideas form - IM Webview
export const IDEA_FORM = "/globalOps-survey";
export const IDEA_FORM_SUCCESS = "/globalOps-surevy-success";


export const GLOBAL_FORM = "/globalAndroid-survey";
export const GLOBAL_FORM_SUCCESS = "/globalAndroid-survey-success";

export const SENTINEL_COACH_FORM = "/sentinel-coach-activity-log";
export const SENTINEL_COACH_FORM_SUCCESS = "/sentinel-coach-activity-log-success";
// Dashboard 2.0

export const DASHBOARD_2 = "/dashboard-2";
export const DASHBOARD_2_1 = "/dashboard-2-1";
// WareHouse TimeLine View
export const WARE_HOUSE_TIMELINE_VIEW = "/wareHouseTimeLine";

export const REST_LAST_PUNCH_ID_VIEW = "/resetLastPunchId";

export const UNDELETE_WORKER = "/undeleteWorker";
// WareHouse Project Upload
export const WAREHOUSE_PROJECT_UPLOAD = "/warehouseProjectUpload";

export const CONTRACTOR_TIMESHEET = "/contractorTimesheet";

export const ITCONTRACTOR_UPLOAD = "/itContractorUpload";

// constant for improjectdata
export const IMPROJECTDATA ="IM Project";

// constant for Contractor Timesheet Report
export const CONTRACTOR_TIMESHEET_REPORT = "/review/ContractorTimesheetReports";

export const ADD_EDIT_WORKER = "/add-edit-worker";

export const VEHICLE_SUPPLIER_CHECKLIST_FORMS = "/vehicle-supplier-checklist-forms";
export const VEHICLE_SUPPLIER_CHECKLIST_FORM_SUCCESS = "/vehicle-supplier-checklist-form-success";
